export default {
  // Breakpoints
  xsmall: '20em',
  small: '26em',
  medium: '40em',
  large: '59em',
  sxlarge: '70em',
  xlarge: '78em',
  xxlarge: '92em',
};
